import styled from "@emotion/styled";

export const WidgetWrapper = styled.div`
  page-break-inside: avoid;
  width: 100%;
`;
